// removed by extract-text-webpack-plugin
module.exports = {"item":"src-components-Landing-BreachItem----BreachItem-module---item---aT9Vb","link":"src-components-Landing-BreachItem----BreachItem-module---link---1KTG2","flexSection":"src-components-Landing-BreachItem----BreachItem-module---flexSection---1nGHz","logoWrapper":"src-components-Landing-BreachItem----BreachItem-module---logoWrapper---1Zoea","logo":"src-components-Landing-BreachItem----BreachItem-module---logo---aXXYa","title":"src-components-Landing-BreachItem----BreachItem-module---title---IemH7","meta":"src-components-Landing-BreachItem----BreachItem-module---meta---2_OEk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Landing/BreachItem/BreachItem.module.css
// module id = 731
// module chunks = 35783957827783